module.exports = __webpack_public_path__ + "img/pro_jinniao_03.2562170a.png";